/*
Sohel 09/19/2022 3075154998 Data Manager Matching Logic ->Integrated API,Added System Notes and Suggested Changes
*/
import React from 'react';
import AddMatchingLogicForm from './AddMatchingLogicForm';

const AddMatchingLogic = ({setValue}) => {
  return (
    <>
      <AddMatchingLogicForm setValue={setValue}/>
    </>
  );
};

export default AddMatchingLogic;
